<header class="h-100">
  <mdb-navbar SideClass="navbar fixed-top navbar-expand-lg navbar-dark scrolling-navbar intro-fixed-nav" [containerInside]="false">
    <mdb-navbar-brand>
      <a class="logo navbar-brand" href="/home#aboutAsips">
        <strong>Asips</strong>
      </a>
    </mdb-navbar-brand>
    <links>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/home">Home
            <span class="sr-only">(current)</span>
          </a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/verify">Verify</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/view_pulsar">View Pulsar Signals</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/view_pulsar_non_pulsar">View Pulsar & non Pulsar Signals</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/test_with_another_algorithm">Test with Another Algorithm</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/help">About</a>
        </li>
      </ul>
    </links>
  </mdb-navbar>
  <!-- Main -->
  <div class="view position-relative">
    <div class="row position-absolute d-flex justify-content-center" style=" width: 100%; margin-top: 35vh">
      <div class="col-md-6 mx-auto">
    <div class=" d-flex ">
      <div class="text-center white-text wow fadeInUp">
        <h2><b>A</b>utomated <b>S</b>ystem for <b>I</b>dentifying <b>P</b>ulsar <b>S</b>tars</h2>
        <br>
        <h5><i>"Pulsars are the lighthouses in space"</i></h5>
        <br>
        <p>Automated system for identifying pulsar star signals among pulsar candidates</p>
        <p>using Gaussian Hellinger Extremely Fast Decision Tree.</p>
      </div>
    </div>
      </div></div>

    <div class="  " style=" position:absolute;bottom:10px;right:10px;">
      <div class="view-round rounded-circle hoverable">
        <div class="mask flex-center rgba-blue-grey-light rounded-circle">
        </div>
      </div>
    </div>



    <ng-particles [id]="id" [options]="particlesOptions">
    </ng-particles>

</div>

  <!-- /.Main -->

</header>
<!--Main Navigation-->

